// extracted by mini-css-extract-plugin
export var fadeIn = "styles-module--fadeIn--GvwCh";
export var fadeInAndMoveUp = "styles-module--fadeInAndMoveUp--U9HMr";
export var label = "styles-module--label--yg2at";
export var learnMore = "styles-module--learnMore--RDN8g";
export var pressBanner = "styles-module--pressBanner--Nugy2";
export var pressBannerWrapper = "styles-module--pressBannerWrapper--q+kEF";
export var scaleUp = "styles-module--scaleUp--bkjcV";
export var slideIn = "styles-module--slideIn--rNKqj";